export default __webpack_public_path__ + "static/media/gallery1.385c60f3.jpg";